import dayjs, { Dayjs, OpUnitType, QUnitType } from 'dayjs'
import 'dayjs/locale/ru'
dayjs.locale('ru')

type IDate = string | Date | Dayjs

export function format(date: IDate, format: string) {
  return dayjs(date).format(format)
}

export function addMonths(date: IDate, count: number) {
  return dayjs(date).add(count, 'month').toDate()
}

export function addYears(date: IDate, count: number) {
  return dayjs(date).add(count, 'year')
}

export function isBefore(date1: IDate, date2: IDate, unit?: OpUnitType) {
  return dayjs(date1).isBefore(date2, unit)
}

export function differenceInMonths(date1: IDate, date2: IDate) {
  return dayjs(date1).diff(dayjs(date2), 'month')
}
